import { render, staticRenderFns } from "./Prematch.vue?vue&type=template&id=4717f156&"
import script from "./Prematch.vue?vue&type=script&lang=js&"
export * from "./Prematch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports